import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFormData } from 'Services/Features/Branch/branchSlice';
import { getDoctor } from 'Services/Features/Doctor/Utils/doctorUtils'

const SelectDoctor = () => {
    const dispatch = useDispatch();
    const doctor = useSelector(state => state.branch.currentBranch.doctor);

    const filter = useSelector(state => state.doctor.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeDoctor = (selectedOption) => {
        setSelectedValue(selectedOption === null ? [] : selectedOption);
        dispatch(setFormData({ doctor_id: selectedOption === null ? [] : selectedOption.map(item => item.value) }));
    };

    useEffect(() => {
        const selectedDoctor = doctor?.length > 0 ? doctor.map(item => ({
            value: item.id,
            label: item.name,
        })) : selectedValue;
        setSelectedValue(selectedDoctor);
        dispatch(setFormData({ doctor_id: doctor?.length > 0 ? doctor.map(item => item.id) : [] }));
    }, []);

    const promiseOptionDoctor = (inputValue, callback) => {
        dispatch(getDoctor({
            ...filter,
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionDoctor}
            handleChange={(selectedOption) => handleChangeDoctor(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Dokter"
            isMulti={true}
        />
    )
}

export default SelectDoctor;
